/*
 * Copyright (c) 2018 Integral Agile, Inc. All rights reserved.
 *   Use of this file is subject to the terms and conditions defined in the file
 * 'LICENSE.txt'
 *   which is distributed in the root directory of this source code tree.
 */

import React from 'react';
import PropTypes from 'prop-types';
import Store from '../../store/store';
import { taskId } from '../../utils/string';
import { openModal } from '../../actions/modalActions';
import modalTypes from '../../constants/modalTypes';
import Holon from '../Buttons/holon';

const SimpleTask = ({ task, workPackage, owners = [] }) => {
  const workPackageTypeId = workPackage.type_id;
  return (
    <div
      className="panel panel-default task"
      style={{ width: '9.4em', height: '10em' }}
    >
      <div className="panel-heading" style={{ cursor: 'move' }}>
        <div className="panel-title">
          <div className="col-xs-4">
            <a
              onClick={() =>
                Store.dispatch(
                  openModal(modalTypes.taskDetail, {
                    id: task.id,
                    task,
                    workPackageTypeId
                  })
                )
              }
            >
              {taskId(task, workPackageTypeId)}
            </a>
          </div>
          <div className="col-xs-4 text-center">
            <Holon action={e => e.stopPropagation()} />
          </div>
          <div className="col-xs-4 text-right">{task.estimate || 0.0}</div>
        </div>
      </div>
      <div className="panel-body">
        <p>{task.short_name}</p>
      </div>
      <div className="panel-footer">
        {owners.length === 0 && <div className="initial right">&nbsp;</div>}
        {owners.map((owner, index) => {
          const initials =
            owner && owner.name
              ? owner.name
                  .split(' ')
                  .map(n => n.charAt(0))
                  .join('')
              : null;
          return (
            <div className="initial right" key={owner.id}>
              {initials || task.owner_initials[index]}
            </div>
          );
        })}
      </div>
    </div>
  );
};

SimpleTask.propTypes = {
  task: PropTypes.object.isRequired,
  workPackage: PropTypes.object,
  owners: PropTypes.array
};

export default SimpleTask;
